import {
  IScenarioDataModel,
  IScenarioTransactionDataModel,
  ScenarioTransactionType,
  ScenarioTransactionTypeToLabel,
  ScenarioType,
} from '../../../../data-models/scenario.data-model';

export function getSimulationLabels(scenario: ValidScenarioModel) {
  return new Set(
    scenario.scenarioTransactions?.map((transaction) => {
      return ScenarioTransactionTypeToLabel[transaction.type];
    })
  );
}

export function filterScenarios(
  scenarios: IScenarioDataModel[],
  search: string,
  creatorEmails: string[] | null
) {
  let filteredScenarios = scenarios;
  if (creatorEmails !== null && creatorEmails.length > 0) {
    filteredScenarios = scenarios.filter((sc) => !!sc.createdBy && creatorEmails.includes(sc.createdBy));
  }
  if (search) {
    filteredScenarios = filteredScenarios.filter((sc) => {
      return sc.name.toLowerCase().includes(search.toLowerCase());
    });
  }
  return filteredScenarios;
}

export function getExistingScenarioTypes(scenarios: IScenarioDataModel[]) {
  const tagSet = new Set<ScenarioType>();
  scenarios.forEach((scenario) => {
    scenario.tags?.forEach((tag) => {
      if (tag) {
        tagSet.add(tag);
      }
    });
  });
  return tagSet;
}

export interface ValidScenarioModel extends Omit<IScenarioDataModel, 'id'> {
  id?: number;
}

// just a stub for now, will need to be updated once we know all required fields for visualization
export function isValidScenarioModel(
  draftScenario: Partial<IScenarioDataModel>
): draftScenario is ValidScenarioModel {
  return 'scenarioTransactions' in draftScenario && 'companyId' in draftScenario;
}

// A transaction has enough data to run if its type-specific required inputs are set.
// A round needs a fundData array — empty means no participation, which is valid — whose
// every row is complete. Null is rejected to match the schema.
function hasRunnableTransactionData(transaction: Partial<IScenarioTransactionDataModel>): boolean {
  switch (transaction.type) {
    case ScenarioTransactionType.round:
      return (
        transaction.roundId != null &&
        transaction.fundData != null &&
        transaction.fundData.every((fund) => fund?.fundId != null)
      );
    case ScenarioTransactionType.exit:
      return transaction.exitValuation != null;
    case ScenarioTransactionType.partialExit:
      return transaction.exitValuation != null && !!transaction.partialExitBreakdown?.length;
    default:
      return false;
  }
}

// Guards POST /scenario/run against empty draft scenarios. Refreshing an unsaved
// scenario resets state to blank defaults; running those 500s the backend.
export function isRunnableScenario(
  draftScenario: Partial<IScenarioDataModel>
): draftScenario is ValidScenarioModel {
  return (
    isValidScenarioModel(draftScenario) &&
    !!draftScenario.scenarioTransactions?.length &&
    draftScenario.scenarioTransactions.every(hasRunnableTransactionData)
  );
}
